import {
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Grid,
  GridItem,
  Modal,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

export function CreditScoreModal() {
  const { t } = useTranslation();

  return (
    <Modal>
      <Dialog>
        {({ close }) => (
          <>
            <DialogHeader onClose={close}>
              {t("Equifax credit score")}
            </DialogHeader>
            <DialogContent>
              <Grid>
                <GridItem>
                  <Text style="global/body-primary">
                    <Trans>
                      Credit scores typically range from 300 to 900. Within that
                      range, scores can usually be placed into one of five
                      categories:
                    </Trans>
                  </Text>
                </GridItem>
                <GridItem>
                  <Text style="global/heading-medium">
                    <Trans>800 to 900</Trans>
                  </Text>
                  <Text style="global/body-primary">
                    <Trans>
                      Individuals with scores in this range are seen as very
                      reliable when it comes to financial responsibility.
                      They're typically the safest bet for landlords or
                      employers looking for trustworthy tenants or employees.
                    </Trans>
                  </Text>
                </GridItem>
                <GridItem>
                  <Text style="global/heading-medium">
                    <Trans>740 to 799</Trans>
                  </Text>
                  <Text style="global/body-primary">
                    <Trans>
                      Individuals in this range have a solid track record of
                      managing their credit responsibly. Landlords or employers
                      may find them to be dependable candidates for leases or
                      employment opportunities.
                    </Trans>
                  </Text>
                </GridItem>
                <GridItem>
                  <Text style="global/heading-medium">
                    <Trans>670 to 739</Trans>
                  </Text>
                  <Text style="global/body-primary">
                    <Trans>
                      This range indicates that individuals have demonstrated
                      responsible credit behavior, making them generally
                      reliable candidates for landlords or employers. They're
                      viewed as dependable with their financial commitments.
                    </Trans>
                  </Text>
                </GridItem>
                <GridItem>
                  <Text style="global/heading-medium">
                    <Trans>580 to 699</Trans>
                  </Text>
                  <Text style="global/body-primary">
                    <Trans>
                      Individuals in this category may have had some credit
                      challenges in the past, but they're not necessarily
                      high-risk. Landlords or employers may consider them as
                      potential tenants or employees, though they might require
                      closer scrutiny
                    </Trans>
                  </Text>
                </GridItem>
                <GridItem>
                  <Text style="global/heading-medium">
                    <Trans>300 to 579</Trans>
                  </Text>
                  <Text style="global/body-primary">
                    <Trans>
                      Individuals with scores in this range may face
                      difficulties in securing new credit. For landlords or
                      employers, this could indicate potential financial
                      instability.
                    </Trans>
                  </Text>
                </GridItem>
                <GridItem>
                  <Text style="global/body-primary">
                    <Trans>
                      Note: score ranges and their corresponding details are
                      derived from Equifax and in no way reflect the opinion or
                      recommendation of Certn.
                    </Trans>
                  </Text>
                </GridItem>
              </Grid>
            </DialogContent>
            <DialogFooter>
              <ButtonGroup>
                <PrimaryButton size="medium" onPress={close}>
                  <Trans>Close</Trans>
                </PrimaryButton>
              </ButtonGroup>
            </DialogFooter>
          </>
        )}
      </Dialog>
    </Modal>
  );
}
